if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    window.addEventListener('click', function(e){
        if (document.getElementById('top-content').contains(e.target)){
            document.getElementById('top-content').classList.add('active');
        }else{
            document.getElementById('top-content').classList.remove('active');
            document.getElementById('lesplanade-arrow').classList.remove('active');
            document.getElementById('lepetit-arrow').classList.remove('active');
            document.querySelector('.side--left').classList.remove('hover');
            document.querySelector('.side--right').classList.remove('hover');
            document.querySelector('.side--left').classList.remove('closed');
            document.querySelector('.side--right').classList.remove('closed');
        }
    })

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.gallery-slides-mobile').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px'
    })

    $('.gallery-slides').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        
        let currentSlider = slick.$slider[0]
        if (currentSlider === null || currentSlider.length === 0) return

        let sliderLayout = currentSlider.querySelectorAll('.slick-slide.next-next-slider--layout, .slick-slide.prev-slider--layout, .slick-slide.current-slider--layout')
        sliderLayout.forEach(slide => {
            slide.classList.remove('current-slider--layout')
            slide.classList.remove('next-next-slider--layout')
            slide.classList.remove('prev-slider--layout')
        })

        let currSlider = currentSlider.querySelector(`[data-slick-index="${nextSlide}"].slick-slide`)
        let nextSlider = currentSlider.querySelector(`[data-slick-index="${nextSlide + 2}"].slick-slide`)
        let prevSlider = currentSlider.querySelector(`[data-slick-index="${nextSlide - 1}"].slick-slide`)

        currSlider.classList.add('current-slider--layout')
        nextSlider.classList.add('next-next-slider--layout')
        prevSlider.classList.add('prev-slider--layout')
    })

    // $('.gallery-slides').on('beforeChange', function(){
    //     let img = document.querySelectorAll(".gallery-block__image.slick-active"); 

    //     let attrImageActive0_3 = "transform: translateY(0); height:400px;"
    //     let attrImageActive1_4 = "transform: translateY(190px); height:400px;"
    //     let attrImageActive2 = "transform: translateY(52px); height:577px;"

    //     img[0].setAttribute("style", attrImageActive0_3);
    //     img[1].setAttribute("style", attrImageActive1_4);
    //     img[2].setAttribute("style", attrImageActive2);
    //     img[3].setAttribute("style", attrImageActive0_3);
    //     img[4].setAttribute("style", attrImageActive1_4);
    // });

    // Slick Slider with current slide number

    let $homeSlider = $('.review-slider');
    $homeSlider.slick({
        autoplaySpeed: 5000
    });

    $('.review-slider').each((i, el) => {
        let currentIndex = '1';

        $(el).on('init', (e, s) => {
            if (s.options.dots) {
                $(s.options.appendDots).append(`<span class="slick-current_index">${currentIndex}</span>`);
            } else if (s.options.arrows) {
                $(s.options.appendArrows).prepend(`<span class="slick-current_index">${currentIndex}</span>`);
            }
        });

        $(el).on('beforeChange', (e, s, c, n) => {
            currentIndex = (`${(n + 1)}`).slice(-2);
            if (s.options.dots) {
                $('.slick-current_index', s.options.appendDots).text(currentIndex);
            } else if (s.options.arrows) {
                $('.slick-current_index', s.options.appendArrows).text(currentIndex);
            }
        });

        $(el).slick();
    });

    //Slick Slider with slide count number

    var $status = $('.pagingInfo');
    var $slickElement = $('.review-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        $status.text(slick.slideCount);
    });

    //progress slider bar
    let $bar = $('.slider-progress__bar');
    $bar.addClass('active');
    $homeSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $bar.removeClass('active');
        setTimeout(function () {
            $bar.addClass('active');
        }, 50)
    });

})();